import * as Vue from "vue"
import * as types from '../../mutation-types'
import {removeItem, addOrUpdateItem} from '../../helpers'

export default {
    [types.APPLY_TABLE_VIEW]: (state, tableViewId) => state.currentId = tableViewId,
    [types.ADD_OR_UPDATE_TABLE_VIEW]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_TABLE_VIEW]: (state, item) => removeItem(state, item),
    [types.SET_TABLE_COLUMN_NAMES]: (state, tableColumnNames) => state.tableColumnNames = tableColumnNames,
}
